<template>
    <v-container>
        <v-row class='my-ad-list'>
            <v-col cols='12'>
                <h3 class='font-weight-bold'>
                    {{ $route.query.agentAds ? 'آگهی‌های نماینده' : 'آگهی‌های من' }}
                </h3>
            </v-col>
            <v-col >
                <v-btn
                    type='primary'
                    class='pa-4'
                    style='height: auto'
                    :color="$vuetify.theme.dark ? 'primary lighten-5' : 'primary'"
                    outlined
                    @click='chooseUnitDialog = !chooseUnitDialog;'
                >
                    <div class='text-right'>
                        <v-icon class='mb-2 ' large>mdi-plus</v-icon>
                        <div class='font-weight-bold'>ثبت آگهی رایگان</div>
                    </div>
                </v-btn>
                <SelectUnitForCreateAds v-model="chooseUnitDialog"/>
            </v-col>
            <v-col>
                <v-btn
                    type='primary'
                    class='pa-4'
                    style='height: auto'
                    :color="$vuetify.theme.dark ? 'primary lighten-5' : 'primary'"
                    outlined
                    :to="{ name: 'Explore' }"
                >
                    <div class='text-right'>
                        <v-icon class='mb-2 ' large>mdi-map-search-outline</v-icon>
                        <div class='font-weight-bold'>مشاهده همه آگهی ها</div>
                    </div>
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-container class='px-0'>
                    <v-row>
                        <v-col
                            v-for='item in ads'
                            :key='item._id'
                            cols='12'
                            sm='4'
                            md='3'
                        >
                            <v-card outlined>
                                <v-card-text class="d-flex">
                                    <v-chip
                                        small
                                        :color='adStatusColor[item.status]'
                                    >
                                        {{ adTra.status[item.status] }}
                                    </v-chip>
                                    <v-spacer></v-spacer>

                                </v-card-text>
                                <AdItem :item='item'/>
                            </v-card>

                            <!--<RealEstateAdDetail :ad='item' :agent-ads='$route.query.agentAds' />-->
                        </v-col>
                        <InitialLoading :init-loading='loadingFetchAdsData'/>
                        <v-col
                            v-if='!loadingFetchAdsData && ads.length === 0'
                            class='ad-item text-center'
                            cols='12' sm='6'
                        >
                            <p>موردی یافت نشد</p>
                        </v-col>

                        <div
                            v-intersect='{
                                handler: endIntersect,
                                options: {
                                    delay:1000,
                                    threshold: [0, 0.5, 1.0]
                                }
                            }'
                        />
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    // import RealEstateAdDetail from '@/components/RealEstateAdDetail';
    import AdItem from '@/components/Explore/AdItem';
    import { mapActions, mapState } from 'vuex';
    import InitialLoading from '@/components/initialLoading';
    import SelectUnitForCreateAds from '@/components/SelectUnitForCreateAds';

    export default {
        name: 'MyAds',
        components: { SelectUnitForCreateAds, InitialLoading,/* RealEstateAdDetail,*/AdItem },
        data() {
            return {
                source: axios.CancelToken.source(),
                loadingFetchAdsData: false,

                currentPage: 1,
                totalPage: null,
                total: null,

                ads: [],
                chooseUnitDialog: false
            };
        },
        methods: {
            async endIntersect(entries, observer, isIntersecting) {
                if (isIntersecting && !this.loadingFetchAdsData && this.currentPage < this.totalPage) {
                    this.currentPage += 1;
                    await this.fetchMyAdsData({
                        page: this.currentPage
                    });
                }
            },

            /**
             * Get RealEstate advertisement data
             * @param {{page:number, per_page:number}} option - Pagination
             * @returns {Promise<Array>} Array of RealEstate advertisement data
             */
            async fetchMyAdsData(option = { page: 1, per_page: 20 }) {
                this.loadingFetchAdsData = true;
                let URL = '/api/users/me/ads';
                if (this.$route.query.agentAds) {
                    URL = '/api/agent/ads';
                }

                axios
                    .get(
                        URL,
                        {
                            params: {
                                ...option
                            },
                            cancelToken: this.source.token
                        }
                    )
                    .then(res => {
                        this.ads = [...this.ads, ...res.data.advertisements];
                        this.total = res.data.total;
                        this.totalPage = res.data.totalPage;
                        this.loadingFetchAdsData = false;
                    })
                    .catch(err => {
                        console.error(err);
                        this.loadingFetchAdsData = false;
                    });
            },
            ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        computed: {
            ...mapState({
                adTra: state => state.translate.fa.ads,
                adStatusColor: state => state.statusColor.ads
            })
        },
        async created() {
            await this.fetchMyAdsData();
            await this.setBreadCrumbsTemp({
                key: 'myAds',
                value: {
                    text: ` آگهی های من`,
                    href: `/MyAds`
                }
            });
        },
        async updated() {
            await this.showBreadCrumbs(['explore','myAds']);
        },
        beforeDestroy() {
            this.source.cancel('');
        }
    };
</script>

<style scoped lang='scss'>
    .my-ad-list {
        .v-btn {
            width: 100%;
            height: 100%;
        }
    }
</style>
